var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetaMaskIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1025,
    height: 1025,
    viewBox: "0 0 1025 1025",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_542_3186)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M862.005 871.546L689.114 820.065L558.73 898.006L467.763 897.968L337.303 820.065L164.488 871.546L111.92 694.087L164.488 497.133L111.92 330.613L164.488 124.233L434.526 285.567H591.967L862.005 124.233L914.573 330.613L862.005 497.133L914.573 694.087L862.005 871.546Z",
    fill: "#FF5C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.527 124.233L434.566 285.68L423.826 396.479L164.527 124.233Z",
    fill: "#FF5C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.34 694.163L456.155 784.672L337.34 820.065V694.163Z",
    fill: "#FF5C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.659 544.525L423.823 396.554L277.65 497.169L277.574 497.132V497.207L278.026 600.776L337.302 544.525H337.34H446.659Z",
    fill: "#FF5C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.005 124.233L591.967 285.68L602.669 396.479L862.005 124.233Z",
    fill: "#FF5C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.19 694.163L570.375 784.672L689.19 820.065V694.163Z",
    fill: "#FF5C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.922 497.207H748.96H748.922V497.132L748.884 497.169L602.711 396.554L579.875 544.525H689.194L748.508 600.776L748.922 497.207Z",
    fill: "#FF5C16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.303 820.062L164.488 871.544L111.92 694.16H337.303V820.062Z",
    fill: "#E34807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.623 544.487L479.634 758.4L433.886 639.463L277.953 600.776L337.267 544.487H446.586H446.623Z",
    fill: "#E34807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.188 820.062L862.003 871.544L914.571 694.16H689.188V820.062Z",
    fill: "#E34807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.87 544.487L546.859 758.4L592.607 639.463L748.54 600.776L689.189 544.487H579.87Z",
    fill: "#E34807"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.92 694.085L164.488 497.131H277.538L277.952 600.737L433.886 639.424L479.633 758.361L456.119 784.556L337.304 694.047H111.92V694.085Z",
    fill: "#FF8D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.573 694.085L862.004 497.131H748.955L748.54 600.737L592.607 639.424L546.859 758.361L570.374 784.556L689.189 694.047H914.573V694.085Z",
    fill: "#FF8D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.969 285.567H513.249H434.528L423.826 396.366L479.635 758.25H546.862L602.709 396.366L591.969 285.567Z",
    fill: "#FF8D5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.488 124.233L111.92 330.613L164.488 497.133H277.538L423.787 396.479L164.488 124.233Z",
    fill: "#661800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.951 587.451H362.739L334.854 614.781L433.923 639.349L413.951 587.413V587.451Z",
    fill: "#661800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.006 124.233L914.574 330.613L862.006 497.133H748.956L602.707 396.479L862.006 124.233Z",
    fill: "#661800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.617 587.451H663.904L691.79 614.819L592.607 639.424L612.617 587.413V587.451Z",
    fill: "#661800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.692 827.41L570.373 784.635L546.859 758.44H479.594L456.08 784.635L467.762 827.41",
    fill: "#661800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.689 827.407V898.043H467.76V827.407H558.689Z",
    fill: "#C0C4CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.34 819.99L467.837 898.007V827.372L456.155 784.597L337.34 819.99Z",
    fill: "#E7EBF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.19 819.99L558.693 898.007V827.372L570.375 784.597L689.19 819.99Z",
    fill: "#E7EBF6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_542_3186"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    fill: "white",
    transform: "translate(0.986328 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaMaskIcon);
export default __webpack_public_path__ + "static/media/MetaMask-icon.7023c4ae5667789a9788503e18cccaf9.svg";
export { ForwardRef as ReactComponent };